import { render } from "./PaymentMethodsView.vue?vue&type=template&id=66e36862"
import script from "./PaymentMethodsView.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__